export default "__VITE_ASSET__Db_nL38o__"